/* ─────────────────────────────────────────────────────────────
   Field Renderer Registry — Maps FieldInputType to React components.
   Stores both edit (form) and display (review) components.
   ───────────────────────────────────────────────────────────── */

import type { FieldInputType, FieldRendererProps, FieldDisplayProps } from '../config/types';

type FieldRendererComponent = React.ComponentType<FieldRendererProps>;
type FieldDisplayComponent = React.ComponentType<FieldDisplayProps>;

interface FieldRegistration {
  edit: FieldRendererComponent;
  display: FieldDisplayComponent;
}

const registry = new Map<string, FieldRegistration>();

export function registerRenderer(
  inputType: FieldInputType | string,
  editComponent: FieldRendererComponent,
  displayComponent: FieldDisplayComponent,
) {
  registry.set(inputType, { edit: editComponent, display: displayComponent });
}

export function getRenderer(inputType: FieldInputType | string): FieldRendererComponent | undefined {
  return registry.get(inputType)?.edit;
}

export function getDisplayRenderer(inputType: FieldInputType | string): FieldDisplayComponent | undefined {
  return registry.get(inputType)?.display;
}

export function hasRenderer(inputType: FieldInputType | string): boolean {
  return registry.has(inputType);
}

export { registry };
export type { FieldRendererComponent, FieldDisplayComponent };
